import React, { lazy, useState } from 'react';

// React.lazy, plus a preload() that resolves once the component's code is loaded.
//
// A prerendered page (scripts/prerender.mjs) is already painted when the app
// starts, and React replaces it on its first render. If that render suspended,
// React would put the Suspense fallback in its place and blank a painted page
// until the chunk arrived. So src/index.js preloads the current route's code
// before React renders (preloadRoute in App.js), and a component whose code has
// loaded renders directly instead of suspending.
const lazyWithPreload = (load) => {
  let loaded = null;
  const Lazy = lazy(load);
  const Component = (props) => {
    // Decided once per mount, so a component that mounted through Suspense keeps
    // rendering through it instead of remounting when its code arrives.
    const [Loaded] = useState(() => loaded);
    return Loaded ? <Loaded {...props} /> : <Lazy {...props} />;
  };
  Component.preload = () =>
    load().then((module) => {
      loaded = module.default;
    });
  return Component;
};

export default lazyWithPreload;
